import moment from "moment";
import _ from 'lodash';
import {
	dateFormat
} from '@/utils/date.js'
import i18n from "@/i18n"
import QRCode from "qrcode";
import * as XLSX from 'xlsx';
export const filterDurationTime = (s, e) => {
	let x = moment(s);
	let y = moment(e); //当下时间
	let duration = moment.duration(y.diff(x, 'ms')); //做差
	let days = duration.get('days');
	let hours = duration.get('hours');
	let mins = duration.get('minutes');
	let ss = duration.get('seconds');
	return `${days}d ${hours}h ${mins}min ${ss}s`;
}


export const filterSearchData = (dataList, searchData, param) => {
	let re_list = [];
	if (dataList && searchData && param) {
		searchData.forEach((search) => {
			dataList.forEach((list) => {
				if (list[param] == search) {
					re_list.push(list);
				}
			});
		});
	}
	return re_list;
}


export const paginate = (orders, page, perPage) => {
	if (orders && orders.length) {
		let from = page * perPage - perPage;
		let to = page * perPage;
		return orders.slice(from, to);
	}
}

export function starUI(star) {
	const number = 5 * star
	const arr = [];
	for (let i = 0; i < 5; i++) {
		if (number <= 0) {
			arr[i] = 'ri-star-line';
			continue;
		}
		let current = i + 1;
		if (current <= number) {
			arr[i] = 'ri-star-fill';
		} else if (current - 0.5 <= number) {
			arr[i] = 'ri-star-half-fill';
			break;
		} else {
			arr[i] = 'ri-star-line';
		}
	}
	if (arr.length < 5) {
		for (let i = arr.length; i < 5; i++) {
			arr[i] = 'ri-star-line';
		}
	}
	return arr;
}

export function percentUI(percent) {
	percent = Number(percent);
	// console.log(percent);
	if (percent < 0) {
		return 0;
	}
	if (percent > 100) {
		return 100;
	}
	return percent * 100 > 100 ? 100 : percent * 100;
}

export function stringRegEx(type, string, length) {
	var tstring = string + ''
	if (type == 0) {
		tstring = tstring.replace(/[^0-9]/g, '')
	} else if (type == 1) {
		tstring = tstring.replace(/[^A-Za-z0-9]+$/, '')
	}
	if (tstring.length > length) {
		return tstring.slice(0, length)
	}

	return tstring
}

export function getIndicator(list, key) {
	if (list) {
		const tmp = _.filter(list, { 'field_name': key });
		if (tmp && tmp.length) {
			const titem = tmp[0]
			if (titem.value) {
				return titem.value
			}
		}
	}
	return ''
}

export function dateFormat1(date, format) {
	return dateFormat(date, format)
}

export function dateFormat2(date) {
	return dateFormat(date, 'YYYY-MM-DD')
}

export function findParent(data, targetId, result,) {
	for (let item of data) {
		if (item.id === targetId) {
			//将查找到的目标数据加入结果数组中
			//可根据需求unshift(item.id)或unshift(item)
			result.unshift(item.id)
			return true
		}
		if (item.children && item.children.length > 0) {
			//根据查找到的结果往上找父级节点
			let isFind = findParent(item.children, targetId, result)
			if (isFind) {
				result.unshift(item.id)
				return true
			}
		}
	}
	//走到这说明没找到目标
	return false
}

export function getParentTree(id, tree) {
	let arr = [] //要返回的数组
	for (let i = 0; i < tree.length; i++) {
		let item = tree[i]
		arr = []
		arr.push(item.id) //保存当前节点id
		if (id == item.id) {
			//判断当前id是否是默认id
			return arr //是则退出循环、返回数据
		} else {
			//否则进入下面判断，判断当前节点是否有子节点数据
			if (item.children && item.children.length > 0) {
				//合并子节点返回的数据
				arr = arr.concat(getParentTree(id, item.children ? item.children : []))
				// console.log(arr)
				if (arr.map(item2 => (item2 ? item2.id : '')).includes(id)) {
					//如果当前数据中已包含默认节点，则退出循环、返回数据
					return arr
				}
			}
		}
	}
	console.log(arr);
}

export function getParentIds(tree, nodeId, path = []) {
	for (const node of tree) {
		// 如果找到了目标节点，返回当前路径中的id数组
		if (node.id === nodeId) {
			return path;
		}

		// 如果当前节点有children，则递归地查找子节点
		if (node.children && node.children.length > 0) {
			const result = getParentIds(node.children, nodeId, [...path, node.id]);
			if (result.length > 0) {
				return result;  // 找到目标节点后返回路径
			}
		}
	}
	return [];  // 如果没有找到目标节点，返回空数组
}

export function treeToFlat(tree, parentKey = null) {
	let nodeData = [];
	let links = []
	// let size = 100
	function recurse(nodes, parent, level, size) {
		nodes.forEach((node) => {
			const newNode = {};
			const newNodeLink = {};
			newNode["name"] = i18n.global.locale == 'en' ? node.title_en : node.title
			newNode.id = node.id
			newNode.level = level
			if (parentKey !== null) {
				newNodeLink["source"] = parent != null ? parent.id : '';
				newNodeLink["target"] = node.id;
				newNode.value = size
			}
			// if(size ==100){
			// 	// 把顶级的节点放在中间
			// 	newNode.x =500
			// 	newNode.y =200
			// 	// newNode.fixed= true
			// }else{
			// 	// 自动计算
			// 	newNode.x =null
			// 	newNode.y =null
			// 	// newNode.fixed= false
			// }
			let title = i18n.global.locale == 'en' ? node.title_en : node.title
			if (nodeData.filter(node => node.name === title).length == 0)
				nodeData.push(newNode)
			if (newNodeLink.source != "")
				links.push(newNodeLink);
			if (node.children && node.children.length > 0) {

				recurse(node.children, node, level + 1, size - 15);
			}
		});
		// size -= 10
	}

	recurse(tree, null, 1, 100);
	// console.log(nodeData);
	return { nodeData, links };
}

export function treeToFlat1(tree, parentKey = null) {
	//只查前2层
	let nodeData = [];
	let links = []
	let size = 100
	let number = 1
	function recurse(nodes, parent,) {
		nodes.forEach((node) => {
			const newNode = {};
			const newNodeLink = {};
			let title = i18n.global.locale == 'en' ? node.title_en : node.title
			newNode["name"] = title
			newNode.id = node.id
			newNode.level = node.level
			if (parentKey !== null) {
				newNodeLink["source"] = parent != null ? parent.id : '';
				newNodeLink["target"] = node.id;
				newNode.value = size
			}
			if (nodeData.filter(node => node.name === title).length == 0)
				nodeData.push(newNode)
			if (newNodeLink.source != "")
				links.push(newNodeLink);
			if (node.children && node.children.length > 0 && number > 0) {
				number -= 1
				recurse(node.children, node);
			}
		});
		size -= 10

	}

	recurse(tree, null);
	return { nodeData, links };
}

export const getIdList = (data, val, idList = []) => {
	data.forEach(item => {
		if (item.title.indexOf(val) > -1 || item.title_en.indexOf(val) > -1) {
			idList.push({ title: item.title, id: item.id, title_en: item.title_en, })
		}
		if (item.children && item.children.length) {
			getIdList(item.children, val, idList)
		}
	})
	return idList;
}

export function filterTreeData1(data, searchObj) {
	let result = [];
	data.forEach(item => {
		let match = true;
		if (!item.title.includes(searchObj)) {
			match = false;
		}
		if (match) {
			result.push(item);
		} else if (item.children && item.children.length > 0) {
			let redata = filterTreeData1(item.children, searchObj);
			if (redata && redata.length) {
				let obj = {
					...item,
					children: redata,
				}
				result.push(obj)
			}
		}
	})
	return result;
}



export function getParentId(list, id) {
	for (let i in list) {
		if (list[i].id === id) {
			return [list[i]]
		}
		if (list[i].children != null) {
			let node = getParentId(list[i].children, id);
			if (node !== undefined) {
				return node.concat(list[i])
			}
		}
	}
}


export function getId(list, id) {
	for (let i in list) {
		if (list[i].id == id) {
			return [list[i]]
		}
		if (list[i].children) {
			let node = getParentId(list[i].children, id);
			if (node !== undefined) {
				return node;
			}
		}
	}
}

export const getNewline = (val, length = 10) => {
	// 按指定字符数换行，中文占2个字符 
	let str = new String(val);
	let bytesCount = 0;
	let s = "";
	for (let i = 0, n = str.length; i < n; i++) {
		let c = str.charCodeAt(i);
		// 统计字符串的字符长度
		if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
			bytesCount += 1;
		} else {
			bytesCount += 2;
		}
		// 换行
		s += str.charAt(i);
		if (bytesCount >= length) {
			s = s + '\n';
			// 重置
			bytesCount = 0;
		}
	}
	return s;
}

export function getLangValue(...args) {
	// 获取缓存信息中英文的值
	// 根据当前语言获取
	let module, key;
	if (args.length == 2) {
		module = args[0];
		key = args[1];
	} else {
		// menu.xx 这种格式
		module = args[0].slice(0, args[0].indexOf('.'))
		key = args[0].slice(args[0].indexOf('.') + 1)
	}
	let obj = sessionStorage.getItem('custom-lang') ? JSON.parse(sessionStorage.getItem('custom-lang')) : [];
	if (obj.length == 0) return ''; // 如果缓存中没有数据，则返回 undefined
	let module_obj = obj.find(item => item.key == module);
	if (typeof module_obj != 'undefined' && module_obj.value) {
		let current = module_obj.value.find(item => item.key == key);
		if (current) {
			return i18n.global.locale == 'en' ? current?.name_en : current?.name; // 返回最终层级的值
		}
	}
	return ''
}

export function getEnZhName(obj) {
	return i18n.global.locale == 'en' ? obj?.name_en : obj?.name; // 返回最终层级的值
}

export function getLangValueByKey(moduleStr, key1 = 'ch', type = 1) {
	// 指定显示 中引文
	let module, key;
	let arr = moduleStr.split('.')
	if (arr.length == 2) {
		// menu.xx 这种格式
		module = arr[0]
		key = arr[1]
	} else {
		// module = xx.yy  key =zz 这种格式 type==1
		// module =xx  key=yy.zz  第二种  type ==2 
		if (type == 1) {
			const [module1, module2, ...arr1] = arr;
			module = module1 + '.' + module2;
			key = arr1.join('.');
		} else {
			const [module1, ...arr1] = arr;
			module = module1;
			key = arr1.join('.');
		}
	}
	let obj = sessionStorage.getItem('custom-lang') ? JSON.parse(sessionStorage.getItem('custom-lang')) : [];
	if (obj.length == 0) return ''; // 如果缓存中没有数据，则返回 undefined
	let module_obj = obj.find(item => item.key == module);
	if (typeof module_obj != 'undefined' && module_obj.value) {
		let current = module_obj.value.find(item => item.key == key);
		if (current) {
			return key1 == 'en' ? current?.name_en : current?.name; // 返回最终层级的值
		}
	}
	return ''; // 返回最终层级的值
}

export function makeQrCode({ type, id, content }, is_public = false) {
	// type =1 机构二维码   =2 产品二维码
	// 相关id
	// lang 当前语言
	if (!type || (!id && !content)) {
		throw 'type is need!! id and content is need one bwtween then';
	}
	let opts = {
		errorCorrectionLevel: "M",
		margin: 1,
		width: 300,
		height: 300,
		quality: 1,
		color: {
			dark: "#000",
			light: "#FFF",
		},
	};
	let href = window.location.href
	let arr = href.split('/#/')
	let website = arr[0]
	let lang = i18n.global.locale;
	let token = ''
	let timestamp = '';
	let storeData = sessionStorage.getItem('set_menu_list');
	if (storeData) {
		storeData = JSON.parse(storeData)
		token = storeData.token;
		timestamp = storeData.timestamp;
	}
	if (type == 1) {
		// console.log(`${website}/#/organization/${id}?lang=${lang}&token=${token}`);
		return QRCode.toDataURL(`${website}/#/organization/${id}?lang=${lang}&token=${token}&timestamp=${timestamp}`, opts)
	} else if (type == 2) {
		// console.log(`${website}/#/passwort/${id}?lang=${lang}&token=${token}`);
		return QRCode.toDataURL(`${website}/#/passwort/${id}?lang=${lang}&token=${token}&timestamp=${timestamp}&is_public=${is_public ? 1 : 0}`, opts)
	} else {
		// 跳转到文字页
		// console.log(`${website}/#/code?content=${content}`);
		return QRCode.toDataURL(`${website}/#/code?content=${content}`, opts)
	}
}

export async function getExcelData(file) {
	let excelData; // excel数据
	// 转为异步
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = function (e) {
			const data = new Uint8Array(e.target.result);
			const workbook = XLSX.read(data, { type: 'array' });
			const firstSheetName = workbook.SheetNames[0];
			const worksheet = workbook.Sheets[firstSheetName];
			excelData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
			resolve(excelData);
		};
		reader.onerror = function (event) {
			reject(event.target.error);
		};
		reader.readAsArrayBuffer(file);
	});
}

export function highlightText(searchText) {
	// 高亮 滚动到搜索的标签
	const inputElements = document.querySelectorAll('.form-control');

	// 遍历所有匹配的 input 元素，获取其值
	inputElements.forEach((inputElement, index) => {
		console.log(`Input ${index + 1} value: ${inputElement.value}`);
		if (searchText == inputElement.value) {
			// 高亮搜索到的文本
			inputElement.style.backgroundColor = '#ffffcc';
			// 滚动到该标签
			inputElement.scrollIntoView();
		}
	});
}

export function truncate(str, length = 10) {
	if (!str) return '';
	return str.length > length ? str.slice(0, length) + '...' : str;
}

export function formateValue(value) {
  // 格式化数据  强制保留2位小数   四舍五入
  if (value === null || value === undefined || value === '' || value ===0) {
    return '0.00';
  }
  return Number(value).toFixed(2);
}

export function switch_company_type_list_to_language_config(companyTypeList) {
	// 把后端返回的公司类型列表 -> 语言配置里面的数据 只有name 根据语言切换获取中文或英文
	// supplier
	// manufacturer
	// buyer
	// wholesaler
	// importer_exporter
	// brand_owner
	// retailer
	// service_provider
	// testing_agency
	// certification_body
	// industry_organization
	// academic_organization
	// educational_institution
	// research_institution
	// market_regulatory_authority

	const list =[
        {
            "id": "1",
            "name": getLangValue('my.account','supplier'),
        },
        {
            "id": "2",
            "name": getLangValue('my.account','manufacturer'),
        },
        {
            "id": "3",
            "name": getLangValue('my.account','buyer'),
        },
        {
            "id": "4",
            "name": getLangValue('my.account','wholesaler'),
        },
        {
            "id": "9",
            "name": getLangValue('my.account','importer_exporter'),
        },
        {
            "id": "10",
            "name": getLangValue('my.account','brand_owner'),
        },
        {
            "id": "5",
            "name": getLangValue('my.account','retailer'),
        },
        {
            "id": "6",
            "name": getLangValue('my.account','service_provider'),
        },
        {
            "id": "7",
            "name": getLangValue('my.account','testing_agency'),
        },
        {
            "id": "8",
            "name": getLangValue('my.account','certification_body'),
        },
        {
            "id": "11",
            "name": getLangValue('my.account','industry_organization'),
        },
        {
            "id": "12",
            "name": getLangValue('my.account','academic_organization'),
        },
        {
            "id": "13",
            "name": getLangValue('my.account','educational_institution'),
        },
        {
            "id": "14",
            "name": getLangValue('my.account','research_institution'),
        },
        {
            "id": "15",
            "name": getLangValue('my.account','market_regulatory_authority'),
        }
    ]
	console.log(list);
	// 根据id匹配name
	return companyTypeList.map(item => ({
		...item,
		name: list.find(i => i.id == item.id)?.name || '',
	}))	
}




